import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
      throw new Error('UserContext must be used within a CommonProvider');
    }
    return context;
};